import React from "react";
import { useNavigate } from "react-router-dom";
import "./AdminMenu.css";

const COLORS = [
  "#1F1F1F", "#2C3E50", "#3B3B98", "#4834D4", "#6F1E51", "#B33771",
  "#E55039", "#E58E26", "#009432", "#006266", "#1B9CFC", "#0652DD",
  "#2C2C54", "#6F4E37", "#4B4B4B", "#353b48", "#833471", "#192A56",
  "#30336B", "#130f40"
];

const AdminMenu = ({ menuItems }) => {
  const navigate = useNavigate();

  return (
    <div className="admin-menu-grid">
      {menuItems.length > 0 ? (
        menuItems.map((item, index) => (
          <div
            key={index}
            className="admin-menu-box"
            onClick={() => navigate(item.link)}
            style={{
              backgroundColor: COLORS[index % COLORS.length],
              color: "#fff",
            }}
          >
            <i className={`fas ${item.icon} admin-menu-icon`}></i>
            <span className="admin-menu-name">{item.name}</span>
          </div>
        ))
      ) : (
        <p className="admin-loading">Loading menu...</p>
      )}
    </div>
  );
};

export default AdminMenu;
